import * as persistanceKeys from '@web-platform/shared-universal-constants/src/persistanceKeys';
import { SEARCH_PARAMS_CHANGED } from '@web-platform/shared-universal-constants/src/userSearch';
import { tryGetValue } from '@web-platform/shared-universal-utils-frontend/src/helpers/sessionStorage';

import { DEPARTURE_TIMES_FILTER_CHANGED, FILTERS_RESET } from '../../../../../../actions/filters';

import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { DepartureTimesState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/departureTimes';
import type { FiltersState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/state';

export const INITIAL_STATE: DepartureTimesState = [];
// @ts-expect-error FiltersState type is not compatible with empty object
const getFiltersFromSession = (): FiltersState => tryGetValue(persistanceKeys.FILTERS, {});

const getDepartureTimesFromSession = (): DepartureTimesState =>
  getFiltersFromSession()?.departureTimes ?? INITIAL_STATE;

export const createDepartureTimesReducer =
  (getInitialState: () => DepartureTimesState = getDepartureTimesFromSession) =>
  (state: DepartureTimesState = getInitialState(), action: Action): DepartureTimesState => {
    switch (action.type) {
      case DEPARTURE_TIMES_FILTER_CHANGED: {
        const newArray = state.slice();
        newArray[action.payload.legIndex] = { ...action.payload };
        return newArray;
      }

      case FILTERS_RESET:
        return [...INITIAL_STATE];

      case SEARCH_PARAMS_CHANGED:
        return state;

      default:
        return state;
    }
  };

export default createDepartureTimesReducer();
export const get = (state: DepartureTimesState): DepartureTimesState => state;
